import { Vue, Component, Mixins } from 'vue-property-decorator';

import { State } from 'vuex-class';
import { UserState } from '@/store/types';


@Component({})
export default class UserMixin extends Vue {

    // State
    @State('user')
    public userState!: UserState;

    public get isLoggedIn(): boolean {
        if (this.userState && this.userState.user) {
            return true;
        }
        return false;
    }

    public get isDemo(): boolean {
        if (this.userState
            && this.userState.user
            && this.userState.user.roles
            && this.userState.user.roles.some((t) => t === 'Demo')) {
            return true;
        }
        return false;
    }

    public get isDeveloper(): boolean {
        return (this.userState && this.userState.user
            && this.userState.user.roles && this.userState.user.roles.indexOf('Developer') > -1) || false;
    }

    public verifyLoginStatus(requiresLoggedIn: boolean): boolean {
        if (!requiresLoggedIn && this.isLoggedIn) {
            this.$router.push('/devices');
            return false;
        } else if (requiresLoggedIn && !this.isLoggedIn) {
            this.$router.push('/login');
            return false;
        }
        return true;
    }
}
